<template>
  <ion-page>
    <ion-content fullscreen />
    <ion-footer
      v-if="user"
      class="ion-padding footer-onboarding"
    >
      <h1>
        {{ $t('onboarding.welcome') }} {{ user.customer.data.name }}
      </h1>
      <p>
        {{ $t('onboarding.intro') }}
      </p>

      <form
        ref="form"
        @submit.prevent="validate($refs.form) && onboardingAddress()"
      >
        <ion-label
          color="medium"
          class="block ion-margin-top ion-margin-bottom-sm text-sm"
          required
        >
          {{ $t('general.first_name') }} *
        </ion-label>
        <ion-input
          v-model="user.customer.data.name"
          required
        />

        <ion-grid class="ion-no-padding">
          <ion-row>
            <ion-col
              size="5"
              class="ion-padding-end-sm"
            >
              <ion-label
                color="medium"
                class="block ion-margin-top ion-margin-bottom-sm text-sm"
              >
                {{ $t('general.preposition') }}
              </ion-label>
              <ion-input v-model="user.customer.data.preposition" />
            </ion-col>
            <ion-col>
              <ion-label
                color="medium"
                class="block ion-margin-top ion-margin-bottom-sm text-sm"
              >
                {{ $t('general.last_name') }} *
              </ion-label>
              <ion-input
                v-model="user.customer.data.surname"
                required
              />
            </ion-col>
          </ion-row>
        </ion-grid>
        <ion-label
          color="medium"
          class="block ion-margin-top ion-margin-bottom-sm text-sm"
        >
          {{ $t('general.birthdate') }}
        </ion-label>
        <ion-datetime
          v-model="user.customer.data.birthday"
        />
        <ion-button
          expand="block"
          type="submit"
        >
          {{ $t('onboarding.continue') }}
        </ion-button>
      </form>

      <ion-grid class="ion-no-padding ion-margin-top">
        <ion-row>
          <ion-col>
            <ul class="progress">
              <li class="active" />
              <li />
              <li />
              <li />
              <li />
            </ul>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-footer>
  </ion-page>
</template>

<script>
import { defineComponent } from 'vue';
import {
  IonFooter, IonInput, IonDatetime, modalController,
} from '@ionic/vue';
import OnboardingAddress from '@/components/OnboardingAddress.vue';
import ErrorMixin from '@/mixins/ErrorMixin';
import OnboardingMixin from '@/mixins/OnboardingMixin';
import ValidationMixin from '@/mixins/ValidationMixin';
import UserService from '@/services/User';

export default defineComponent({
  components: {
    IonFooter,
    IonInput,
    IonDatetime,
  },
  mixins: [ErrorMixin, OnboardingMixin, ValidationMixin],
  async created() {
    await UserService.getProfile();
  },
  methods: {
    /**
     * Go to onboarding address.
     */
    async onboardingAddress() {
      await this.handleErrors(async () => {
        await modalController.dismiss();

        const modal = await modalController.create({
          component: OnboardingAddress,
          showBackdrop: false,
          backdropDismiss: false,
        });
        await modal.present();
      });
    },
  },
});
</script>

<style scoped>
ion-content {
  --background: none;
}
</style>
